import { render, staticRenderFns } from "./PatentOwnerForm.vue?vue&type=template&id=2a73521c&"
import script from "./PatentOwnerForm.vue?vue&type=script&lang=js&"
export * from "./PatentOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentOwnerForm.vue?vue&type=style&index=0&id=2a73521c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports